import { Close as CloseIcon } from '@mui/icons-material';
import { Dialog, DialogContent, DialogTitle, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { FileUploader } from '@/common';
import { addFileToAuditorVisit } from '../api/addFileToAuditorVisit';
import { useAuditorVisitDetailContext } from '../contexts/AuditorVisitDetailContext';

type FileUploadModalProps = {
  show: boolean;
  setShow: (show: boolean) => void;
};

const FileUploadModal = ({ show, setShow }: FileUploadModalProps) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { t } = useTranslation();
  const { auditorVisit, invalidateAuditorVisit } = useAuditorVisitDetailContext();

  return (
    <Dialog
      fullScreen={fullScreen}
      open={show}
      onClose={() => setShow(false)}
      aria-labelledby="responsive-dialog-title"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h5">{t('Upload files', { defaultValue: 'Upload files' })}</Typography>
        <CloseIcon sx={{ fontSize: '2rem', cursor: 'pointer' }} onClick={() => setShow(false)} />
      </DialogTitle>
      <DialogContent>
        <FileUploader
          onFileUpload={async (file) => {
            const formData = new FormData();

            formData.append('title', file.file.name);
            formData.append('attachments', file.file);

            // eslint-disable-next-line no-promise-executor-return
            await new Promise((r) => setTimeout(r, 800));

            return addFileToAuditorVisit({ id: auditorVisit.id, formData });
          }}
          onUploadFinished={(allFilesSuccessfullyUploaded) => {
            invalidateAuditorVisit();

            if (allFilesSuccessfullyUploaded) {
              setShow(false);
            }
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default FileUploadModal;
